
import { Tbl_playerEdit } from './tbl_playerEdit';
import { Tbl_playerList } from './tbl_playerList';
import { Tbl_playerShow } from './tbl_playerShow';
import { Tbl_playerCreate } from './tbl_playerCreate';
import MapIcon from '@material-ui/icons/Map';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: Tbl_playerList,
    edit: Tbl_playerEdit,
    show: Tbl_playerShow,
    create: Tbl_playerCreate,
    icon: MapIcon
};
            